<template>
  <div class="bond-manage">
    <div class="form-block">
      <div class="form-title">
        <div class="form-icon"></div>
        <div class="flex">上传缴费凭证</div>
      </div>
      <div class="form-content">
        <div class="tips">
          保证金是指服务商入驻应用市场时缴纳的一定金额的款项，用以作为服务商在合作期内为用户提供诚实守信的应用服务的担保
        </div>
        <div class="btn-block">
          <el-button type="primary" class="upload-btn" @click="bondProof">上传凭证</el-button>
        </div>
      </div>
    </div>
    <div class="form-block">
      <div class="form-title">
        <div class="form-icon"></div>
        <div>缴费方式</div>
        <div class="flex rest-money">
          <img src="../../assets/img/bond-rest-money.svg" alt="">
          保证金余额：{{restMoney}}元
        </div>
      </div>
      <div class="form-content">
        <div class="tips">
          <span class="warning">*</span> 转账时请备注：应用市场保证金+开发者公司全称；如：应用市场保证金+XX有限公司。
        </div>
      </div>
      <div class="form-content">
        <div class="form-cell full-cell">
          <div class="form-label">公司名称：</div>
          <div class="form-value ">{{compSetting.payeeName}}</div>
        </div>
        <div class="form-cell full-cell">
          <div class="form-label">开户行：</div>
          <div class="form-value ">{{compSetting.bankName}}</div>
        </div>
        <div class="form-cell full-cell">
          <div class="form-label">账户：</div>
          <div class="form-value ">{{compSetting.bankAccount}}</div>
        </div>
      </div>
    </div>
    <div class="form-block">
      <div class="form-title">
        <div class="form-icon"></div>
        <div class="flex">凭证上传记录</div>
      </div>
      <div class="form-content table-block " style="height: 300px">
        <new-table :data="tableData" :columns="columns" :pages="pages"></new-table>
      </div>
    </div>
  </div>
</template>

<script>

  import PaySettingService from "../../apis/paySettingService";
  import BondService from "../../apis/bondService";
  import OrderService from "../../apis/orderService";
  import newTable from "../../components/new-table"

  export default {
    name: "bond-manage",
    components: { newTable },
    data() {
      return {
        tableData: [],
        compSetting: {},
        restMoney: 0,
        tableData1: [{name: 1}],
        columns: [
          {label: "付款账户", prop: "payAccount", "min-width":"180"},
          {label: "付款金额", prop: "payMoney", "min-width":"100"},
          {label: "付款截图", prop: "payPic", "min-width":"90", previewProp: 'previewPayPic', img: true, imgWidth: "32px", imgHeight: "32px",
            render:(h,scope) => {
              return (
                  <div style="display:flex;align-items: center;justify-content: center;">
                    <el-image
                        style="height:32px"
                    src={scope.row.payPic}
                    preview-src-list={ [scope.row.previewPayPic] }>
                  </el-image>
                  </div>
              )
            }
          },
          {label: "是否开收据", prop: "issueReceipt", "min-width":"100"},
          {label: "审批状态", prop: "auditStatus", "min-width":"90"},
          {label: "审批描述", prop: "auditRemark", "min-width":"180"},
          {label: "审批人", prop: "auditUserName", "min-width":"90"},
          {label: "审核时间", prop: "auditTime", "min-width":"150"},
          {label: "收据状态", prop: "receiptIssued", "min-width":"90"},
          {label:"操作","min-width":"120",
            render:(h,scope) => {
            return (
                <div>
                  <el-popover
                      v-show={scope.row.canShowMore}
                      popper-class="bond-popper"
                      ref="popover"
                      placement="bottom"
                      width="200"
                      trigger="click">
                    <el-form label-width="60px">
                      <el-form-item label="联系人">
                        <span>{this.popoverRow.realName}</span>
                      </el-form-item>
                      <el-form-item label="联系方式">
                        <span>{this.popoverRow.phone}</span>
                      </el-form-item>
                      <el-form-item label="Email">
                        <span>{this.popoverRow.email}</span>
                      </el-form-item>
                      <el-form-item label="收据说明" v-show={ this.popoverRow.canShowReceipt }>
                        <span>{this.popoverRow.receiptRemark}</span>
                      </el-form-item>
                    </el-form>
                    <span class="handle-btn" slot="reference" on={{
                      "click":()=> {
                        this.more(scope.row)
                      }
                    }}>更多</span>
                  </el-popover>
                  <span class="handle-btn revoke" on={{
                    "click":()=>{
                      this.revoke(scope.row)
                    }
                  }} v-show={scope.row.canRevoke}>撤回</span>
                </div>
            )
            }
          }
        ],
        pages: {
          props: {
            "page-size": 20,
            "current-page": 1,
            "total": 0,
            "page-sizes": [10, 20, 50, 100],
          },
          on: {
            "current-change": (p) => {
              this.currentChange(p)
            },
            "size-change":(p) => {
              this.sizesChange(p)
            }
          }
        },
        popoverRow: {}
      }
    },
    mounted() {
      this.getCompSetting();
      this.getTableData();
    },
    methods: {
      more(row) {
        this.popoverRow = row;
      },
      async revoke(row) {
        try {
          const confirm = await  this.$confirm('确定要撤回本条凭证上传记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          if (confirm !== "confirm") return;
          const res = await BondService.revokeCoDeposit(row.id);
          this.$message.success("撤回成功");
          this.currentChange(1);
        } catch (e) {
          console.log(e);
        }
      },
      async getTableData() {
        const res = await BondService.getCoDepositList({
          pageIndex: this.pages.props["current-page"],
          pageSize: this.pages.props["page-size"],
          total: this.pages.props.total,
        });
        this.restMoney = OrderService.toYuan(res.restMoney);
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      },
      async getCompSetting() {
        const res = await  PaySettingService.getGlobalSetting();
        this.compSetting = res;
      },
      sizesChange(val) {
        this.pages.props["page-size"] = val;
        this.getTableData();
      },
      currentChange(currentPage) {
        this.pages.props["current-page"] = currentPage;
        this.getTableData();
      },
      bondProof() {
        this.$router.push({path: `/bond-manage/bond-proof`})
      }
    }
  }
</script>

<style scoped lang="scss">

  .bond-manage {
    ::v-deep  .form-block {
      margin-bottom: 35px;
      &:last-of-type {
        margin-bottom: 0;
      }
      .form-title {
        height: 32px;
        line-height: 32px;
        display: flex;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        .form-icon {
          width: 4px;
          background-color: #1B9AEE;
          margin-right: 20px;
        }
      }
      .form-content {
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;

        .tips {
          color: #999;
          .warning {
            color: red;
          }
        }
        .form-cell {
          display: flex;
          width: 100%;
          font-size: 14px;
          color: #333;
          margin-bottom: 30px;

          .form-label {
            color: #666;
            min-width: 80px;
          }
          &:last-of-type {
            margin-bottom: 0;
          }
        }
        .handle-btn {
          color: #409EFF;
          cursor: pointer;
          margin-left: 8px;
        }
      }
      .btn-block {
        margin: -30px 0 0 50px;
        .upload-btn {
          padding: 11px 30px;
        }
      }
      .rest-money {
        margin-left: 20px;
        font-size: 16px;
        color: #333;
        img {
          vertical-align: middle;
          width: 20px;
          margin-right: 5px;
        }
      }

    }
  }

</style>
<style lang="scss">
  .bond-popper {
    padding: 20px;
    .el-form-item__label {
      font-size: 12px;
      text-align: left;
    }
    .el-form-item__content {
      font-size: 12px;
    }
    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
    }
  }
</style>
